var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('span', { staticClass: "form-item-label" }, [_vm._v(_vm._s(_vm.label) + "\n  "), _vm.desc ? _c('auto-tips', { style: { 'margin-left': '3px' }, attrs: { "content": _vm.desc, "max-length": 0, "tooltipProps": { effect: 'dark' } } }) : _vm._e()], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };